import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { withLoader, withErrorHandling } from '@/store/thunks/thunkWrappers';
import type { UserStatus } from '@/types/organization.types';
import { OrgUserStatus } from '@/types/status.types';

export const toggleUserActiveThunk = createAdminAsyncThunk<
  undefined,
  { id: string; currentStatus: UserStatus }
>(
  'organizationUsers/toggleActive',
  withLoader(
    withErrorHandling(
      async({ id, currentStatus }, { extra: { usersService } }) => {
        const newStatus: UserStatus = currentStatus === OrgUserStatus.Active ? OrgUserStatus.Inactive : OrgUserStatus.Active;
        await usersService.toggleActiveUser(id, newStatus);
        return undefined;
      }
    )
  )
);
